import { TRACK_ACTION, TRACK_PAGE_VIEW } from "redux/ActionTypes";

export const trackPageView = (eventType, metadata = {}) => ({
  type: TRACK_PAGE_VIEW,
  payload: {
    eventType,
    metadata,
  },
});

export const trackAction = (eventType, metadata = {}) => ({
  type: TRACK_ACTION,
  payload: {
    eventType,
    metadata,
  },
});
